import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteNote } from '../../services/NotesService';
import { Note, DeleteNoteRequest } from '../../types/Notes';

type Result = UseMutationResult<Note, Error, DeleteNoteRequest>;

function useDeleteNote(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteNote, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['notes'] });
      queryClient.invalidateQueries({ queryKey: ['notes-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteNote;
